import React from 'react';
import { Checkbox, Row, Col, Modal, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const showValidationResultInfo = (fileUploadInfos, rootContainer, onOk) => {
  const skippedFiles = fileUploadInfos.filter((f) => f.isSuccess === false);
  const renamedFiles = fileUploadInfos.filter((f) => f.renamed === true);

  const suffix = skippedFiles.length + renamedFiles.length > 1 ? 's' : '';

  const renamedSuffix = renamedFiles.length > 1 ? 's' : '';
  const skippedSuffix = skippedFiles.length > 1 ? 's' : '';

  const onChange = (event, fileInfo) => {
    const checked = event.target.checked;
    fileInfo.renamed = checked;
  };

  Modal.info({
    getContainer: rootContainer,
    title: `File${suffix} Validation Result${suffix}`,
    width: 650,
    content: (
      <div style={{ overflowY: 'auto', maxHeight: '650px' }}>
        {skippedFiles.length ? (
          <>
            <div style={{ fontWeight: 'bold', marginBottom: '15px' }}>Following file{skippedSuffix} will not be loaded:</div>
            <ul>
              {skippedFiles?.map((obj) => (
                <li key={obj.newFileId}>{obj.message}</li>
              ))}
            </ul>
            <div style={{ fontWeight: 'bold', margin: '15px 0px' }}>
              Total: {skippedFiles.length} file{skippedSuffix}
            </div>
          </>
        ) : null}
        {renamedFiles.length ? (
          <>
            <div style={{ fontWeight: 'bold', marginBottom: '15px' }}>
              {/* Folder contains file{renamedSuffix} with the following name{renamedSuffix}. */}
              Please select file{renamedSuffix} you want to upload with a new name. Unselected file{renamedSuffix} will be overwritten.
            </div>
            <Row gutter={24} style={{ margin: '0px 0px' }}>
              <Col offset={20} span={4} style={{ display: 'flex', justifyContent: 'center' }}>
                Rename
              </Col>
            </Row>
            {renamedFiles?.map((obj) => (
              <Row id={'file-validation-' + obj.newFileId} gutter={24} style={{ margin: '0px 0px' }} key={'rename-wrap-' + obj.newFileId}>
                <Col span={20} key={'file-validation-filename-' + obj.newFileId}>
                  <Tooltip
                    key={'file-validation-tooltip-' + obj.newFileId}
                    getPopupContainer={() => document.getElementById('file-validation-filename-' + obj.newFileId)}
                    title={obj.message + ' Please check/uncheck to rename/replace.'}
                  >
                    <span>{obj.fileName}</span>
                  </Tooltip>
                </Col>
                <Col span={4} style={{ display: 'flex', justifyContent: 'center' }} key={'file-validation-checkbox-' + obj.newFileId}>
                  <Checkbox onChange={($event) => onChange($event, obj)} key={obj.newFileId} name={obj.fileName} defaultChecked={obj.renamed} />
                </Col>
              </Row>
            ))}
            <div style={{ fontWeight: 'bold', margin: '15px 0px' }}>
              Total: {renamedFiles.length} file{renamedSuffix}
            </div>
          </>
        ) : null}
      </div>
    ),
    okText: 'Confirm',
    onOk: onOk,
    maskClosable: true,
    onCancel: (close) => {
      close();
    },
  });
};

export const showRenameSelectedFilesModal = (existingfileNames, rootContainer, onOk, onCancel) => {
  Modal.confirm({
    getContainer: rootContainer,
    title: 'Rename selected item(s)?',
    icon: <ExclamationCircleOutlined />,
    content: (
      <div>
        <div style={{ fontWeight: 'bold', marginBottom: '15px' }}>
          Destination folder contains item(s) with the following name(s). Do you want to rename selected item(s)?
        </div>
        <ul>
          {existingfileNames.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
    ),
    okText: 'Yes',
    cancelText: 'No',
    onOk: onOk,
    onCancel: onCancel
      ? onCancel
      : (close) => {
          close();
        },
  });
};
